module.exports = __webpack_public_path__ + "img/save-icon.8c280c77.svg";